import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { MoreHorizontal, LogIn, Lock, Trash2, MailCheck } from "lucide-react";
import { badgeStyle } from "@/utils/szStatus";
import { getApprovalConfig, approvalOptions, avatarColor, userInitials, userDisplayName } from "./userConstants";

const UsersMobileCards = ({
  users, selectedUsers, onToggleSelect,
  onViewProfile, onRemoveBounce, onLoginAs, onEdit, onPasswordReset, onDelete, onApprovalChange,
}) => (
  <div className="md:hidden flex flex-col gap-[11px]">
    {users.map((user) => {
      const isSelected = selectedUsers.has(user.id);
      const cfg = getApprovalConfig(user.approval_status || "new");

      return (
        <div
          key={user.id}
          className="sz-card p-3.5"
          style={{ borderLeft: `4px solid ${cfg.fg}` }}
        >
          {/* Top: avatar + name + status */}
          <div className="flex items-center gap-[11px]">
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onToggleSelect(user.id)}
              className="w-4 h-4 cursor-pointer accent-[#572B7C] shrink-0"
              aria-label="Select row"
            />
            <div
              className="w-10 h-10 rounded-full text-white flex items-center justify-center font-bold text-[13px] shrink-0 overflow-hidden"
              style={{ background: avatarColor(user.id || user.email), fontFamily: "Poppins" }}
            >
              {user.profile_photo_url
                ? <img src={user.profile_photo_url} alt="" className="w-full h-full object-cover" />
                : userInitials(user)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{userDisplayName(user)}</div>
              <div className="text-[11.5px] text-[#8A90A2] sz-mono">USR-{user.user_number}</div>
            </div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="sz-badge cursor-pointer" style={badgeStyle(cfg)}>{cfg.label}</button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {approvalOptions.map((opt) => {
                  const OptIcon = opt.icon;
                  return (
                    <DropdownMenuItem key={opt.key} onClick={() => onApprovalChange(user.id, opt.status, opt.notify)}>
                      <OptIcon className={`w-4 h-4 mr-2 ${opt.iconColor}`} />{opt.label}
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>

          {/* Contact lines */}
          <div className="mt-[11px] flex flex-col gap-1 text-[12.5px] text-[#2B3142]">
            <div className={`flex items-center gap-1.5 ${user.email_bounced ? "text-[#EA580C]" : ""}`}>
              {user.email_bounced && <span className="w-[7px] h-[7px] rounded-full bg-[#EA580C] shrink-0" />}
              <span className="truncate">{user.email}</span>
            </div>
            <div className="text-[#8A90A2]">
              {[user.phone, user.business_name].filter(Boolean).join(" · ") || "—"}
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-2 mt-3">
            <button
              onClick={() => onViewProfile(user)}
              className="flex-1 py-2 border border-[#E0E3EB] rounded-[9px] bg-white text-xs font-semibold text-[#2B3142]"
            >
              View
            </button>
            <button
              onClick={() => onEdit(user)}
              className="flex-1 py-2 border border-[#E0E3EB] rounded-[9px] bg-white text-xs font-semibold text-[#2B3142]"
            >
              Edit
            </button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="w-9 flex items-center justify-center border border-[#E0E3EB] rounded-[9px] bg-white text-[#2B3142]">
                  <MoreHorizontal className="w-4 h-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem onClick={() => onLoginAs(user)}><LogIn className="w-4 h-4 mr-2 text-blue-500" />Login As User</DropdownMenuItem>
                <DropdownMenuItem onClick={() => onPasswordReset(user.id, user.email)}><Lock className="w-4 h-4 mr-2 text-gray-500" />Password Reset</DropdownMenuItem>
                {user.email_bounced && (
                  <DropdownMenuItem onClick={() => onRemoveBounce(user.id, user.full_name || user.email)}>
                    <MailCheck className="w-4 h-4 mr-2 text-orange-500" />Remove Bounce
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => onDelete(user.id, user.email)} className="text-red-600 focus:text-red-600 focus:bg-red-50">
                  <Trash2 className="w-4 h-4 mr-2" />Delete User
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      );
    })}
  </div>
);

export default UsersMobileCards;
